(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  vtex.define('shipping/script/mixin/withShippingStateMachine',['state-machine/state-machine', 'shipping/script/models/Address'], function(SM, Address) {
    return function() {
      var stateMachineEvents;
      stateMachineEvents = [
        {
          name: 'showList',
          from: 'none',
          to: '_list'
        }, {
          name: 'showForm',
          from: 'none',
          to: '_form'
        }, {
          name: 'showSummary',
          from: 'none',
          to: '_summary'
        }, {
          name: 'showListWithSLA',
          from: '_list',
          to: 'listSLA'
        }, {
          name: 'showListUnavailable',
          from: '_list',
          to: 'listNoSLA'
        }, {
          name: 'showListCantEdit',
          from: '_list',
          to: 'anonListSLA'
        }, {
          name: 'showListCantEditUnavailable',
          from: '_list',
          to: 'anonListNoSLA'
        }, {
          name: 'requestSLA',
          from: 'listLoadSLA',
          to: 'listLoadSLA'
        }, {
          name: 'loadSLA',
          from: 'listLoadSLA',
          to: 'listSLA'
        }, {
          name: 'loadNoSLA',
          from: 'listLoadSLA',
          to: 'listNoSLA'
        }, {
          name: 'requestSLA',
          from: 'listSLA',
          to: 'listLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'listNoSLA',
          to: 'listLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'anonListSLA',
          to: 'anonListLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'anonListNoSLA',
          to: 'anonListLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'anonListLoadSLA',
          to: 'anonListLoadSLA'
        }, {
          name: 'loadSLA',
          from: 'anonListLoadSLA',
          to: 'anonListSLA'
        }, {
          name: 'loadNoSLA',
          from: 'anonListLoadSLA',
          to: 'anonListNoSLA'
        }, {
          name: 'refresh',
          from: 'anonListSLA',
          to: 'listSLA'
        }, {
          name: 'refresh',
          from: 'anonListNoSLA',
          to: 'listNoSLA'
        }, {
          name: 'showList',
          from: 'anonListSLA',
          to: '_list'
        }, {
          name: 'showList',
          from: 'anonListNoSLA',
          to: '_list'
        }, {
          name: 'showForm',
          from: 'anonListSLA',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'anonListNoSLA',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'listSLA',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'listLoadSLA',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'listNoSLA',
          to: '_form'
        }, {
          name: 'showSummary',
          from: 'listSLA',
          to: '_summary'
        }, {
          name: 'showSummary',
          from: 'anonListSLA',
          to: '_summary'
        }, {
          name: 'showSearch',
          from: '_form',
          to: 'search'
        }, {
          name: 'editAddressSLA',
          from: '_form',
          to: 'addressFormSLA'
        }, {
          name: 'editAddressNoSLA',
          from: '_form',
          to: 'addressFormNoSLA'
        }, {
          name: 'newAddress',
          from: '_form',
          to: 'addressForm'
        }, {
          name: 'searchAddress',
          from: 'search',
          to: 'addressFormLoad'
        }, {
          name: 'loadAddress',
          from: 'addressFormLoad',
          to: 'addressForm'
        }, {
          name: 'requestSLA',
          from: 'addressForm',
          to: 'addressFormLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'addressFormLoad',
          to: 'addressFormLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'addressFormSLA',
          to: 'addressFormLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'addressFormLoadSLA',
          to: 'addressFormLoadSLA'
        }, {
          name: 'requestSLA',
          from: 'addressFormNoSLA',
          to: 'addressFormLoadSLA'
        }, {
          name: 'loadSLA',
          from: 'addressFormLoadSLA',
          to: 'addressFormSLA'
        }, {
          name: 'loadNoSLA',
          from: 'addressFormLoadSLA',
          to: 'addressFormNoSLA'
        }, {
          name: 'showSearch',
          from: 'addressForm',
          to: 'search'
        }, {
          name: 'showSearch',
          from: 'addressFormSLA',
          to: 'search'
        }, {
          name: 'showSearch',
          from: 'addressFormNoSLA',
          to: 'search'
        }, {
          name: 'showSearch',
          from: 'addressFormLoadSLA',
          to: 'search'
        }, {
          name: 'showForm',
          from: 'search',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'addressForm',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'addressFormLoad',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'addressFormLoadSLA',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'addressFormSLA',
          to: '_form'
        }, {
          name: 'showForm',
          from: 'addressFormNoSLA',
          to: '_form'
        }, {
          name: 'showList',
          from: 'search',
          to: '_list'
        }, {
          name: 'showList',
          from: 'addressForm',
          to: '_list'
        }, {
          name: 'showList',
          from: 'addressFormLoad',
          to: '_list'
        }, {
          name: 'showList',
          from: 'addressFormLoadSLA',
          to: '_list'
        }, {
          name: 'showList',
          from: 'addressFormSLA',
          to: '_list'
        }, {
          name: 'showList',
          from: 'addressFormNoSLA',
          to: '_list'
        }, {
          name: 'showSummary',
          from: 'addressFormSLA',
          to: '_summary'
        }, {
          name: 'showSummary',
          from: '_summary',
          to: 'summary'
        }, {
          name: 'showEmpty',
          from: '_summary',
          to: 'empty'
        }, {
          name: 'showList',
          from: 'empty',
          to: '_list'
        }, {
          name: 'showForm',
          from: 'empty',
          to: '_form'
        }, {
          name: 'showSummary',
          from: 'empty',
          to: '_summary'
        }, {
          name: 'showList',
          from: 'summary',
          to: '_list'
        }, {
          name: 'showForm',
          from: 'summary',
          to: '_form'
        }, {
          name: 'showSummary',
          from: 'summary',
          to: '_summary'
        }
      ];
      this.createStateMachine = function() {
        return StateMachine.create({
          events: stateMachineEvents,
          callbacks: {
            on_list: this.on_List.bind(this),
            onlistSLA: this.onListSLA.bind(this),
            onlistNoSLA: this.onListNoSLA.bind(this),
            onlistLoadSLA: this.onListLoadSLA.bind(this),
            onleaveListLoadSLA: this.onLeaveListLoadSLA.bind(this),
            onanonListSLA: this.onAnonListSLA.bind(this),
            onanonListNoSLA: this.onAnonListNoSLA.bind(this),
            onanonListLoadSLA: this.onAnonListLoadSLA.bind(this),
            onLeaveAnonListLoadSLA: this.onLeaveAnonListLoadSLA.bind(this),
            on_form: this.on_Form.bind(this),
            onsearch: this.onSearch.bind(this),
            onaddressForm: this.onAddressForm.bind(this),
            onaddressFormLoad: this.onAddressFormLoad.bind(this),
            onleaveaddressFormLoad: this.onLeaveAddressFormLoad.bind(this),
            onaddressFormSLA: this.onAddressFormSLA.bind(this),
            onleaveaddressFormSLA: this.onLeaveAddressFormSLA.bind(this),
            onaddressFormNoSLA: this.onAddressFormNoSLA.bind(this),
            onaddressFormLoadSLA: this.onAddressFormLoadSLA.bind(this),
            on_summary: this.on_Summary.bind(this),
            onsummary: this.onSummary.bind(this),
            onleavesummary: this.onLeaveSummary.bind(this),
            onempty: this.onEmpty.bind(this),
            onleaveempty: this.onLeaveEmpty.bind(this),
            onafterevent: this.onAfterEvent.bind(this)
          }
        });
      };
      this.onBeforeEvent = function(event, from, to) {
        return console.log("Enter " + to);
      };
      this.onAfterEvent = function() {
        if (this.attr.data.active) {
          this.select('shippingStepSelector').addClass('active', 'visited');
          return this.select('shippingStepTitleSelector').addClass('accordion-toggle-active');
        } else {
          this.select('shippingStepSelector').removeClass('active');
          return this.select('shippingStepTitleSelector').removeClass('accordion-toggle-active');
        }
      };
      this.on_Summary = function(event, from, to, orderForm) {
        var locale, rules, _ref,
          _this = this;
        this.attr.data.active = false;
        this.select('addressListSelector').trigger('disable.vtex');
        this.select('countrySelectSelector').trigger('disable.vtex');
        this.attr.componentsState.addressForm = false;
        this.select('addressFormSelector').trigger('disable.vtex');
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        this.select('addressNotFilledSelector').hide();
        this.select('goToPaymentButtonWrapperSelector').hide();
        if (this.isValid()) {
          locale = this.attr.locale;
          rules = this.attr.data.countryRules[(_ref = this.attr.orderForm.shippingData.address) != null ? _ref.country : void 0];
          return this.attr.stateMachine.next = function() {
            return _this.attr.stateMachine.showSummary(orderForm, locale, rules);
          };
        } else {
          return this.attr.stateMachine.next = function() {
            return _this.attr.stateMachine.showEmpty();
          };
        }
      };
      this.onEmpty = function(event, from, to) {
        this.select('addressListSelector').trigger('disable.vtex');
        this.select('countrySelectSelector').trigger('disable.vtex');
        this.attr.componentsState.addressForm = false;
        this.select('addressFormSelector').trigger('disable.vtex');
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        this.select('shippingSummarySelector').trigger('disable.vtex');
        return this.select('addressNotFilledSelector').show();
      };
      this.onLeaveEmpty = function(event, from, to) {
        return this.select('addressNotFilledSelector').hide();
      };
      this.onSummary = function(event, from, to, orderForm, locale, rules) {
        this.select('shippingSummarySelector').trigger('enable.vtex', [locale, orderForm.shippingData, orderForm.items, orderForm.sellers, rules, orderForm.canEditData, orderForm.giftRegistryData]);
        return this.select('editShippingDataSelector').show();
      };
      this.onLeaveSummary = function(event, from, to) {
        return this.select('editShippingDataSelector').hide();
      };
      this.on_List = function(event, from, to, orderForm) {
        var hasDeliveries,
          _this = this;
        this.attr.data.active = true;
        this.attr.componentsState.addressForm = false;
        this.select('addressFormSelector').trigger('disable.vtex');
        this.select('countrySelectSelector').trigger('disable.vtex');
        this.select('addressSearchSelector').trigger('disable.vtex', null);
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        this.select('shippingSummarySelector').trigger('disable.vtex');
        this.select('goToPaymentButtonWrapperSelector').hide();
        hasDeliveries = this.attr.data.hasDeliveries;
        if (orderForm.canEditData) {
          if (hasDeliveries) {
            return this.attr.stateMachine.next = function() {
              return _this.attr.stateMachine.showListWithSLA(orderForm);
            };
          } else {
            return this.attr.stateMachine.next = function() {
              return _this.attr.stateMachine.showListUnavailable(orderForm);
            };
          }
        } else {
          if (hasDeliveries) {
            return this.attr.stateMachine.next = function() {
              return _this.attr.stateMachine.showListCantEdit(orderForm);
            };
          } else {
            return this.attr.stateMachine.next = function() {
              return _this.attr.stateMachine.showListCantEditUnavailable(orderForm);
            };
          }
        }
      };
      this.onListSLA = function(event, from, to, orderForm) {
        var deliveryCountries, _ref;
        deliveryCountries = this.attr.data.deliveryCountries;
        this.select('addressListSelector').trigger('enable.vtex', [deliveryCountries, orderForm.shippingData, orderForm.giftRegistryData]);
        this.select('shippingOptionsSelector').trigger('enable.vtex', [(_ref = orderForm.shippingData) != null ? _ref.logisticsInfo : void 0, orderForm.items, orderForm.sellers]);
        return this.select('goToPaymentButtonWrapperSelector').fadeIn("fast");
      };
      this.onListNoSLA = function(event, from, to, orderForm) {
        var deliveryCountries;
        deliveryCountries = this.attr.data.deliveryCountries;
        $(window).trigger('showMessage.vtex', ['unavailable']);
        this.select('addressListSelector').trigger('enable.vtex', [deliveryCountries, orderForm.shippingData, orderForm.giftRegistryData]);
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        return this.select('goToPaymentButtonWrapperSelector').fadeOut("fast");
      };
      this.onAnonListSLA = function(event, from, to, orderForm) {
        var deliveryCountries, _ref;
        deliveryCountries = this.attr.data.deliveryCountries;
        this.select('addressListSelector').trigger('enable.vtex', [deliveryCountries, orderForm.shippingData, orderForm.giftRegistryData]);
        this.select('shippingOptionsSelector').trigger('enable.vtex', [(_ref = orderForm.shippingData) != null ? _ref.logisticsInfo : void 0, orderForm.items, orderForm.sellers]);
        return this.select('goToPaymentButtonWrapperSelector').fadeIn("fast");
      };
      this.onAnonListNoSLA = function(event, from, to, orderForm) {
        var deliveryCountries;
        deliveryCountries = this.attr.data.deliveryCountries;
        $(window).trigger('showMessage.vtex', ['unavailable']);
        this.select('addressListSelector').trigger('enable.vtex', [deliveryCountries, orderForm.shippingData, orderForm.giftRegistryData]);
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        return this.select('goToPaymentButtonWrapperSelector').fadeOut("fast");
      };
      this.onListLoadSLA = function(event, from, to) {
        this.select('addressListSelector').trigger('startLoading.vtex');
        this.select('shippingOptionsSelector').trigger('startLoading.vtex');
        return this.select('goToPaymentButtonWrapperSelector').fadeOut("fast");
      };
      this.onLeaveListLoadSLA = function(event, from, to) {
        this.select('addressListSelector').trigger('stopLoading.vtex');
        return this.select('shippingOptionsSelector').trigger('stopLoading.vtex');
      };
      this.onAnonListLoadSLA = function(event, from, to) {
        this.select('addressListSelector').trigger('startLoading.vtex');
        this.select('shippingOptionsSelector').trigger('startLoading.vtex');
        return this.select('goToPaymentButtonWrapperSelector').fadeOut("fast");
      };
      this.onLeaveAnonListLoadSLA = function(event, from, to) {
        this.select('addressListSelector').trigger('stopLoading.vtex');
        return this.select('shippingOptionsSelector').trigger('stopLoading.vtex');
      };
      this.on_Form = function(event, from, to, orderForm) {
        var address, addressObj, apiCallError, country, deliveryCountries, geoCoordinatesIsValid, hasAvailableAddresses, hasDeliveries, ignoreGeoCoords, logisticsConfiguration, postalCodeIsValid, requestingSLA, rules, storeAcceptsGeoCoords, storeAcceptsPostalCode, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7,
          _this = this;
        this.attr.data.active = true;
        this.attr.componentsState.addressForm = false;
        this.select('addressFormSelector').trigger('disable.vtex');
        this.select('countrySelectSelector').trigger('disable.vtex');
        this.select('addressSearchSelector').trigger('disable.vtex', null);
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        this.select('shippingSummarySelector').trigger('disable.vtex');
        this.select('addressListSelector').trigger('disable.vtex');
        this.select('goToPaymentButtonWrapperSelector').hide();
        deliveryCountries = this.attr.data.deliveryCountries;
        hasAvailableAddresses = this.attr.data.hasAvailableAddresses;
        hasDeliveries = this.attr.data.hasDeliveries;
        logisticsConfiguration = this.attr.data.logisticsConfiguration;
        storeAcceptsPostalCode = (__indexOf.call((_ref = this.attr.data.logisticsConfiguration) != null ? _ref.acceptSearchKeys : void 0, 'postalCode') >= 0);
        storeAcceptsGeoCoords = (__indexOf.call((_ref1 = this.attr.data.logisticsConfiguration) != null ? _ref1.acceptSearchKeys : void 0, 'geoCoords') >= 0);
        apiCallError = this.attr.orderForm.apiCallError;
        this.attr.orderForm.apiCallError = null;
        address = (_ref2 = orderForm.shippingData) != null ? _ref2.address : void 0;
        country = (_ref3 = (_ref4 = address != null ? address.country : void 0) != null ? _ref4 : this.attr.data.country) != null ? _ref3 : deliveryCountries[0];
        rules = this.attr.data.countryRules[country];
        if (!rules) {
          rules = this.attr.data.countryRules[deliveryCountries[0]];
        }
        if (this.attr.stateMachine.from === 'listLoadSLA') {
          requestingSLA = true;
        }
        postalCodeIsValid = address && ((_ref5 = rules.regexes) != null ? _ref5.postalCode : void 0) && rules.regexes.postalCode.test(address.postalCode);
        geoCoordinatesIsValid = address && ((_ref6 = address.geoCoordinates) != null ? _ref6.length : void 0) === 2;
        ignoreGeoCoords = address && address.ignoreGeoCoords;
        if ((!storeAcceptsGeoCoords && rules.queryByPostalCode && !postalCodeIsValid) || (storeAcceptsGeoCoords && geoCoordinatesIsValid === false && postalCodeIsValid === false && ignoreGeoCoords !== true)) {
          this.attr.stateMachine.next = function() {
            return _this.attr.stateMachine.showSearch(rules, address, hasAvailableAddresses, deliveryCountries, logisticsConfiguration);
          };
          return;
        }
        if (address) {
          addressObj = new Address(address);
        }
        if (!apiCallError && (address && (addressObj != null ? addressObj.validate(rules) : void 0) === true || ((addressObj != null ? addressObj.postalCode : void 0) != null) || (addressObj != null ? (_ref7 = addressObj.geoCoordinates) != null ? _ref7.length : void 0 : void 0) === 2)) {
          if (hasDeliveries) {
            return this.attr.stateMachine.next = function() {
              _this.attr.stateMachine.editAddressSLA(orderForm);
              if (requestingSLA) {
                return _this.attr.stateMachine.requestSLA();
              }
            };
          } else {
            return this.attr.stateMachine.next = function() {
              _this.attr.stateMachine.editAddressNoSLA(orderForm);
              if (requestingSLA) {
                return _this.attr.stateMachine.requestSLA();
              }
            };
          }
        } else {
          orderForm.shippingData.address = address = {
            country: country
          };
          address = this.addressDefaults(address);
          if (rules.queryByPostalCode || (storeAcceptsGeoCoords && ignoreGeoCoords !== true)) {
            return this.attr.stateMachine.next = function() {
              return _this.attr.stateMachine.showSearch(rules, address, hasAvailableAddresses, deliveryCountries, logisticsConfiguration);
            };
          } else {
            return this.attr.stateMachine.next = function() {
              return _this.attr.stateMachine.newAddress(orderForm);
            };
          }
        }
      };
      this.onSearch = function(event, from, to, rules, address, hasAvailableAddresses, deliveryCountries, logisticsConfiguration) {
        var defaultCountry, _ref, _ref1;
        defaultCountry = (_ref = this.attr) != null ? (_ref1 = _ref.data) != null ? _ref1.country : void 0 : void 0;
        this.attr.componentsState.addressForm = false;
        this.select('addressFormSelector').trigger('disable.vtex');
        this.select('shippingOptionsSelector').trigger('disable.vtex');
        this.select('countrySelectSelector').trigger('enable.vtex', [deliveryCountries, address, hasAvailableAddresses, defaultCountry]);
        return this.select('addressSearchSelector').trigger('enable.vtex', [rules, address, logisticsConfiguration, defaultCountry]);
      };
      this.onLeaveSearch = function(event, from, to) {
        return this.select('addressSearchSelector').trigger('disable.vtex', null);
      };
      this.onAddressForm = function(event, from, to, orderForm) {
        var address, defaultCountry, deliveryCountries, hasAvailableAddresses, logisticsConfiguration, _ref;
        address = (_ref = orderForm.shippingData) != null ? _ref.address : void 0;
        hasAvailableAddresses = this.attr.data.hasAvailableAddresses;
        deliveryCountries = this.attr.data.deliveryCountries;
        logisticsConfiguration = this.attr.data.logisticsConfiguration;
        defaultCountry = this.attr.data.country;
        this.select('countrySelectSelector').trigger('enable.vtex', [deliveryCountries, address, hasAvailableAddresses, defaultCountry]);
        this.select('addressSearchSelector').trigger('disable.vtex');
        this.attr.componentsState.addressForm = true;
        this.select('addressFormSelector').trigger('enable.vtex', [address, logisticsConfiguration]);
        return this.select('shippingOptionsSelector').trigger('disable.vtex');
      };
      this.onAddressFormLoad = function(event, from, to) {};
      this.onLeaveAddressFormLoad = function(event, from, to) {};
      this.onAddressFormSLA = function(event, from, to, orderForm) {
        var address, defaultCountry, deliveryCountries, hasAvailableAddresses, logisticsConfiguration, _ref, _ref1;
        address = (_ref = orderForm.shippingData) != null ? _ref.address : void 0;
        hasAvailableAddresses = this.attr.data.hasAvailableAddresses;
        deliveryCountries = this.attr.data.deliveryCountries;
        logisticsConfiguration = this.attr.data.logisticsConfiguration;
        defaultCountry = this.attr.data.country;
        this.select('countrySelectSelector').trigger('enable.vtex', [deliveryCountries, address, hasAvailableAddresses, defaultCountry]);
        this.select('addressSearchSelector').trigger('disable.vtex');
        this.attr.componentsState.addressForm = true;
        this.select('addressFormSelector').trigger('enable.vtex', [address, logisticsConfiguration]);
        this.select('shippingOptionsSelector').trigger('enable.vtex', [(_ref1 = orderForm.shippingData) != null ? _ref1.logisticsInfo : void 0, orderForm.items, orderForm.sellers]);
        return this.select('goToPaymentButtonWrapperSelector').fadeIn("fast");
      };
      this.onLeaveAddressFormSLA = function(event, from, to) {
        return this.select('goToPaymentButtonWrapperSelector').hide();
      };
      this.onAddressFormNoSLA = function(event, from, to, orderForm) {
        var address, defaultCountry, deliveryCountries, hasAvailableAddresses, logisticsConfiguration, _ref;
        address = (_ref = orderForm.shippingData) != null ? _ref.address : void 0;
        hasAvailableAddresses = this.attr.data.hasAvailableAddresses;
        deliveryCountries = this.attr.data.deliveryCountries;
        logisticsConfiguration = this.attr.data.logisticsConfiguration;
        defaultCountry = this.attr.data.country;
        $(window).trigger('showMessage.vtex', ['unavailable']);
        this.select('countrySelectSelector').trigger('enable.vtex', [deliveryCountries, address, hasAvailableAddresses, defaultCountry]);
        this.select('addressSearchSelector').trigger('disable.vtex');
        if (!this.attr.componentsState.addressForm) {
          this.attr.componentsState.addressForm = true;
          this.select('addressFormSelector').trigger('enable.vtex', [address, logisticsConfiguration]);
        }
        return this.select('shippingOptionsSelector').trigger('disable.vtex');
      };
      this.onAddressFormLoadSLA = function(event, from, to) {
        return this.select('shippingOptionsSelector').trigger('startLoading.vtex');
      };
      return stateMachineEvents;
    };
  });

}).call(this);

